module.exports = __webpack_public_path__ + "img/card_img_11.d454a8f6.png";